import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderShell, LanguageSwitcher } from '@edraak/design-system';
import { appContext } from 'UILogistration/services/appContext';
import { setLanguage } from 'UIShared/services/setLanguage';
const LANGUAGES = [
    { code: 'ar', label: 'العربية' },
    { code: 'en', label: 'English' },
];
// Marketing is a separate deployment but follows the same i18n_patterns
// convention as this app: Arabic is the unprefixed default, English gets
// a /en prefix.
function getMarketingUrl(language) {
    const base = appContext.EdraakMarketingBase.replace(/\/+$/, '');
    return language === 'en' ? `${base}/en` : base;
}
export function LogistrationHeader() {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.dir() === 'rtl';
    const marketingUrl = getMarketingUrl(i18n.language);
    function handleLanguageChange(code) {
        setLanguage(code, LANGUAGES.map((language) => language.code));
    }
    return (_jsx(HeaderShell, { mobileGroupSide: 'center', start: _jsxs("button", { type: 'button', "data-cy": 'back-to-home-button', onClick: () => {
                window.location.href = marketingUrl;
            }, "aria-label": t('common.goBackHome'), className: 'group flex items-center gap-2 bg-transparent border-0 text-sm font-semibold text-text-black hover:text-secondary focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-sm transition-colors', children: [_jsx("i", { className: isRtl
                        ? 'text-lg fa-solid fa-arrow-right'
                        : 'fa-solid fa-arrow-left', "aria-hidden": 'true' }), _jsx("span", { className: 'hidden sm:inline group-hover:underline', children: t('common.goBackHome') })] }), center: _jsx("a", { href: marketingUrl, "data-cy": 'edraak-logo-link', "aria-label": t('common.edraakHome'), children: _jsx("img", { src: appContext.logoUrl, "data-cy": 'edraak-logo', alt: t('common.edraakLogo'), className: 'w-full max-w-logo max-h-logo lg:max-w-logo-lg lg:max-h-logo-lg' }) }), end: _jsx("div", { "data-cy": 'language-switcher', children: _jsx("div", { "data-cy": 'header-menu-button', children: _jsx(LanguageSwitcher, { languages: LANGUAGES, currentLanguage: i18n.language, onLanguageChange: handleLanguageChange }) }) }) }));
}
